/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useRef, useState } from 'react';
import { SEO_MULTICITY_TEMPLATE } from '../../constants/templateConstants';
import { getAppEnv } from '../../../config/env';
import './MultiCityPage.css';
import CabModifySearch from '../../components/CabModifySearch/CabModifySearch';
import {
  detectUserActivity,
  fetchAndLogXdmEvent,
  generateRequestId,
  isMobile,
  isSEM,
  useSearchWidgetHooks
} from '../../utils/commonUtils';
import MultiCityPackages, {
  ScrollInView
} from '../../components/MultiCityPackages/MultiCityPackages';
import MulticityRouteInfo from '../../components/MulticityRouteInfo/MulticityRouteInfo';
import InboundCallBox from '../../components/InboundCall/InboundCallBox';
import { makeServiceDeskRequest } from '../../cabsAPIs';
import {
  PACKAGE_PAGE_TYPE,
  SCROLL
} from '../../constants/miscellaneousConstants';
import {
  trackMulticityPageEvent,
  trackStatePageEvent
} from '../../utils/omnitureTracking';
import { yeildToMainThread } from '../../scheduler';
import { useMediaQuery } from 'react-responsive';
import AssistModal from '../../components/AssistModal';
import CallUsModal from '../../components/AssistModal/callUsModal';
import { EnvironmentVariables } from '../../types';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import AppContextProvider from '../../AppContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import Helmet from 'react-helmet';
import {
  setDateAsDatePlusN,
  setDeptAndReturnDateForMulticity
} from '../../utils/timeUtils';
import FooterSection from '../../components/Footer/Footer';
import FaqSection from '../../components/Faq/Faq';
import TripAssistant from '../TripAssistant';
import { OUTSTATION_ROUND_TRIP } from '../../constants/tripTypes';
import CompactList from '../../components/CompactList/CompactList';
import TopCabsRoutes from '../../components/TopCabsRoutes/TopCabsRoutes';
import RentalCabPrice from '../../components/RentalCabPrice/RentalCabPrice';
import ProductSchema from '../../utils/ProductSchema';
import TruncateText from '../../components/CompactText/TruncateText';

const ASSISTED_FORM_DATA_LS = 'ASSISTED_FORM_DATA_LS';
const env = getAppEnv();
const { PUBLIC_URL, DATA_LOADER_URL } = env.raw as EnvironmentVariables;
const getImageUrl = imageName => {
  return `${PUBLIC_URL}/static/public/${imageName}`;
};

const ThingsToKeepInMind = ({ thingToKeepInMind }) => {
  return (
    <div className="thingsToRemember leftRightPadding">
      <h2 className="thingsToRememberTitle">Things to keep in mind</h2>
      <ul className="listDisc paddingL15 ">
        {thingToKeepInMind &&
          thingToKeepInMind.length > 0 &&
          thingToKeepInMind.map((info, idx) => {
            return (
              <li key={`ttkim_${idx}`} className="thingsToRememberInfo ">
                {info}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

const WhyChooseUs = ({ whyChooseUs, setShowModal }) => {
  return (
    <div className="WhyChooseUsContainer leftRightPadding">
      <div className="WhyChooseUs">
        <h2 className="WhyChooseUsTitle">Why choose us?</h2>
        {whyChooseUs &&
          whyChooseUs.length > 0 &&
          whyChooseUs.map((info, idx) => (
            <div key={`wcu_${idx}`} className="alignCenter whyBookWithUsPoints">
              <img
                className="whyChooseUsImg lazyload"
                alt=""
                src={getImageUrl('thumbsUp.png')}
              />
              <div className="whyChooseUsPoints">{info}</div>
            </div>
          ))}
      </div>
      <div className="makeFlex perfectCenter">
        <div className="Assistance makeFlex">
          <div className="makeFlex perfectCenter">
            <img
              className="AssistanceImg lazyload"
              alt=""
              src={getImageUrl('assistance-call.png')}
            />
          </div>
          <div className="AssistanceInfo">
            <div className="AssistanceTitle">
              Looking to customise your plan?
            </div>
            <div className="AssistanceSubtitle">
              Reach out for personalized assistance and trip planning.
            </div>
            <div
              onClick={() => {
                setShowModal();
              }}
              className="AssistanceButon makeFlex perfectCenter pushBottom"
            >
              Talk to an expert
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

const KnowMore = ({ dhamInfo, trackTemplateEvent, packageName }) => {
  const dwebCardSizeInPx = 350;
  const scrollerRef = useRef(null);
  const windowRef = useRef(null);
  return (
    <div className="knowMore leftRightPadding">
      <h2 className="knowMoreTitle font24 latoBold blackText">
        {`Know more about ${packageName}`}
      </h2>
      <ScrollInView
        scrollerRef={scrollerRef}
        windowRef={windowRef}
        dwebCardSizeInPx={dwebCardSizeInPx}
        component={
          <div ref={scrollerRef} className="knowMoreSection">
            <div ref={windowRef} className="knowMoreWindow">
              {dhamInfo &&
                dhamInfo.length > 0 &&
                dhamInfo.map(({ img, title, details, url }, idx) => (
                  <div
                    key={`knowmore_${idx}_${title}`}
                    onClick={() => {
                      trackTemplateEvent(`Dham_Info_${title}_Clicked`);
                      window.location = Object(setDateAsDatePlusN(url, 3));
                    }}
                    className="knowMoreCard"
                  >
                    <div className="knowMoreImg lazyload">
                      <img
                        style={{
                          width: '330px',
                          borderRadius: '20px',
                          marginBottom: '5px'
                        }}
                        alt={title}
                        src={`${PUBLIC_URL}/static/public/${img}`}
                      />
                    </div>
                    <div className="knowMoreDham">{title}</div>
                    <div className="knowMoreDhamDetails appendBottom20">
                      {details}
                    </div>
                    <div className="pushBottom viewCab makeFlex perfectCenter lineHeight34">
                      View Cab
                    </div>
                  </div>
                ))}
            </div>
          </div>
        }
      />
    </div>
  );
};

const MulticityPage = ({ data }) => {
  const {
    tripType,
    packages,
    itineraryInfo,
    dhamInfo,
    whyChooseUs,
    thingToKeepInMind,
    assistanceData,
    templateData,
    disableCabCardImage,
    disableStopFilter,
    stopType,
    heroBannerImage,
    heroBannerText,
    heroBannerInfo,
    heroBannerSubInfo,
    aggregateRating,
    schemaMinFare,
    sourceCityCode,
    destinationCityCode,
    sourceCityName,
    destinationCityName,
    seoSource,
    routeImg,
    tooltipText,
    tooltipDelay = 3000,
    pageType,
    interlinks,
    stateName,
    cabRentalPrices,
    primaryCityName,
    topRoutes
  } = data;
  const isPackage = pageType == PACKAGE_PAGE_TYPE;
  const trackTemplateEvent = isPackage
    ? trackMulticityPageEvent
    : trackStatePageEvent;
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const [showAssistantIc, setShowAssistantIc] = useState(false);
  const [showWhatsAppIcon, setWhatsAppIcon] = useState(false);
  const [showCallUsIcon, setCallUsIcon] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const {
    assistedFormOpenDelay = 10000,
    showTripAssistantButton = true,
    showTripAssistantButtonForDweb = true,
    showWhatsappWidget = true,
    whatsappWidgetDeeplink = 'https://wa.me/919951106499?text=Request%20ID%20MDRequest_id%20%0AHi,%20I%20am%20looking%20for%20a%20cab%20from%20Delhi%20to%20Agra',
    customerCareNumber = '01244781861',
    assistantWidgetText = 'You can Call Us or Chat via WhatsApp',
    showWhatsAppForAssistedForm = true,
    showCallUsWidget = false,
    showCallUsForAssistedForm = true,
    inboundCallText = 'Talk to agent (24x7)',
    inboundCallNumber = '0124 - 4781861',
    semCustomerCareNumber = '',
    semInboundCallNumber = '',
    showInboundCallNumberInDesktop = true,
    showCallusModalMweb = false,
    callusModalOpenDelay = 10000,
    showInboundNumberOnAssistedForm = true,
    couponInfo = null,
    showLeaveIntentForm = false
  } = assistanceData;

  let inboundCallNumberFinal = inboundCallNumber;
  let customerCareNumberFinal = customerCareNumber;
  if (isSEM()) {
    inboundCallNumberFinal = semInboundCallNumber;
    customerCareNumberFinal = semCustomerCareNumber;
  }
  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(!!tooltipText);
  const [showTripAssistantTooltip, setShowTripAssistantTooltip] = useState(
    !!tooltipText
  );

  useEffect(() => {
    if (showWhatsAppTooltip) {
      setTimeout(() => {
        setShowWhatsAppTooltip(false);
      }, tooltipDelay);
    }
    if (showTripAssistantTooltip) {
      setTimeout(() => {
        setShowTripAssistantTooltip(false);
      }, tooltipDelay);
    }
  });

  const scrollPosition = useRef(0);
  const assistedFormLifeCycle = useRef(0);

  const { travelFor, pickUpTime, dropTime } = useSearchWidgetHooks(
    SEO_MULTICITY_TEMPLATE
  );

  const userActionDone = () => {
    return window?.localStorage?.getItem('userActionDone') == 'true';
  };

  const setShowModalWithDelay = async val => {
    if (isMobile() && (showCallusModalMweb || showTripAssistantButton)) {
      await yeildToMainThread(() =>
        requestAnimationFrame(() => setShowModal(val))
      );
    }
  };
  const scrollableDivRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrolledHeight =
        window.pageYOffset || document.documentElement.scrollTop;

      // Access the ref's current element and change its style directly
      if (scrollableDivRef.current) {
        const scrolledHeight =
          window.pageYOffset || document.documentElement.scrollTop;
        const stickyWidget = document.getElementById('stickyWidget');

        if (scrolledHeight >= 200) {
          // @ts-ignore
          stickyWidget.classList.add('positionedSearchWidgetForStickyWidget');
        } else {
          // @ts-ignore
          stickyWidget.classList.remove(
            'positionedSearchWidgetForStickyWidget'
          );
        }
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const showModalConsideringScrollEvents = () => {
    if (assistedFormLifeCycle.current != 2 && !userActionDone()) {
      assistedFormLifeCycle.current = 2;
      setShowModalWithDelay(true);
      const eventName =
        showCallusModalMweb && showCallUsForAssistedForm && isMobile()
          ? 'Cab_SEO_Assisted_Call_Us_Form_Shown'
          : 'Cab_SEO_Assisted_Form_Shown';
      trackTemplateEvent(eventName);
    }
  };

  useEffect(() => {
    //
    const handleScroll = () => {
      scrollPosition.current = window.scrollY || window.pageYOffset;

      const scrollDownThreshold = isMobileDevice ? 500 : 900;
      const scrollUpThreshold = scrollDownThreshold - 100;

      if (
        scrollPosition.current > scrollDownThreshold &&
        assistedFormLifeCycle.current == 0
      ) {
        assistedFormLifeCycle.current = 1;
      } else if (
        scrollPosition.current < scrollUpThreshold &&
        assistedFormLifeCycle.current == 1
      ) {
        showModalConsideringScrollEvents();
      }
    };

    // If tripAssistantOpen is true in the query params then open form
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('tripAssistantOpen') === 'true') {
      showModalConsideringScrollEvents();
    }

    // Attach the scroll event listener
    window.addEventListener(SCROLL, handleScroll);
    if (window?.localStorage) {
      localStorage.removeItem(ASSISTED_FORM_DATA_LS);
    }

    openFormDueToInactivity();
    if (showCallUsWidget && isMobile()) {
      setTimeout(() => {
        trackTemplateEvent('Cab_SEO_Call_Us_Icon_Shown');
      }, 500);
    }

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener(SCROLL, handleScroll);
    };
  }, []);

  const openFormDueToInactivity = () => {
    const timeDelay = showCallusModalMweb
      ? callusModalOpenDelay
      : assistedFormOpenDelay;
    setTimeout(() => {
      if (window?.localStorage && assistedFormLifeCycle.current != 2) {
        if (
          !userActionDone() &&
          (isMobile()
            ? showTripAssistantButton || showCallusModalMweb
            : showTripAssistantButtonForDweb)
        ) {
          showModalConsideringScrollEvents();
        } else {
          // not show message should not be shown if modal is already shown
          const userAction = userActionDone();
          trackTemplateEvent(
            `Cab_SEO_Assisted_Form_Not_Shown_userActionDone_${userAction}`
          );
        }
      }
    }, timeDelay);
  };

  useEffect(() => {
    window.addEventListener(SCROLL, listenToScroll);
    detectUserActivity();
    return () => window.removeEventListener(SCROLL, listenToScroll);
  }, []);

  useEffect(() => {
    const url =
      typeof window !== 'undefined'
        ? window.location.href
        : templateData?.sampleUrl || '';
    fetchAndLogXdmEvent(url);
  }, []);

  const listenToScroll = () => {
    const heightToShowFrom = 100;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToShowFrom) {
      if (!(isMobileDevice && showModal)) {
        setShowAssistantIc(true);
        setWhatsAppIcon(true);
        setCallUsIcon(true);
      }
    } else {
      setShowAssistantIc(false);
      setWhatsAppIcon(false);
      setCallUsIcon(false);
    }
  };

  const fabInteraction = () => {
    return (
      <div
        className={` ${(() => {
          if (showTripAssistantButtonForDweb && showTripAssistantButton) {
            return '';
          } else if (showTripAssistantButton) {
            return 'mobileShow';
          } else if (showTripAssistantButtonForDweb) {
            return 'desktopShow';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`fabInteraction ${
            showModal && isMobileDevice
              ? 'showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
          {true && <span>Trip Assistant</span>}
        </div>
      </div>
    );
  };

  const callUsForm = () => {
    return (
      <div
        className={` ${(() => {
          if (showCallusModalMweb) {
            return '';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Call_Us_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`${
            showModal && isMobileDevice
              ? 'fabInteraction showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
        </div>
      </div>
    );
  };

  const onWhatsAppIconClick = () => {
    const requestId = generateRequestId();
    const pageName = 'seo_multicity_page';
    makeServiceDeskRequest(requestId, pageName);
    const whatsAppChatLinkWithRequestId = whatsappWidgetDeeplink
      ? whatsappWidgetDeeplink.replace('MDRequest_id', requestId)
      : '';
    if (whatsAppChatLinkWithRequestId)
      window.location.href = whatsAppChatLinkWithRequestId;
  };

  const onCallUsIconClick = () => {
    window.open(`tel:${customerCareNumberFinal}`, '_blank');
  };

  const handleWhatsappWidget = () => {
    onWhatsAppIconClick();
    trackTemplateEvent('Cab_SEO_WhatsApp_Assisted_Icon_Clicked');
    setShowWhatsAppTooltip(false);
  };

  const handleTooltipClose = e => {
    e.stopPropagation();
    setShowWhatsAppTooltip(false);
  };
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const toggleOverlay = (isVisible: boolean) => {
    setIsOverlayVisible(isVisible);
  };
  return (
    <AppContextProvider
      omniUrlArgs={`source=${seoSource || SEO_MULTICITY_TEMPLATE}`}
      trackTemplateEvent={trackTemplateEvent}
      selectedKnowMoreDetailsForMobile={null}
      setSelectedKnowMoreDetailsForMobile={null}
    >
      <div
        style={{
          backgroundImage: `url(${PUBLIC_URL}/static/public/${heroBannerImage})`
        }}
        className={`${isPackage ? 'chardhamBackgroundImage' : ''} desktopShow`}
      >
        {/* <div className="makeFlex perfectCenter">
          <div className="positionedChardhamHeader">
            <div className="font36 latoBlack blackText makeFlex perfectCenter">
              {heroBannerText}
            </div>
            <div className="font28 latoBlack blackText makeFlex perfectCenter">
              {heroBannerInfo}
            </div>
            {heroBannerSubInfo ? (
              <div className="font28 latoRegular blackText makeFlex perfectCenter">
                {heroBannerSubInfo}
              </div>
            ) : null}
          </div>
        </div> */}
      </div>
      <div id="Chardham" className="cabSeoDtPage">
        <div
          style={{ zIndex: 1 }}
          ref={scrollableDivRef}
          id="stickyWidget"
          className={`desktopShow `}
        >
          <CabModifySearch
            forwardDate={3}
            mcPageStyle={false}
            pickupTime={pickUpTime}
            defaultTripType={
              tripType === 'RT' ? OUTSTATION_ROUND_TRIP : travelFor
            }
            returnTime={dropTime}
            returnCloseFlagDefault={false}
            sourceCityCode={sourceCityCode}
            sourceCityName={sourceCityName}
            // destinationCityCode={isPackage ? destinationCityCode : undefined}
            // destinationCityName={isPackage ? destinationCityName : undefined}
            isMobileDevice={false}
            title={`${isPackage ? 'Multicity' : stateName + ` Cabs`}`}
          />
        </div>

        <div>
          {isMobile() && showWhatsappWidget && (
            <div className="whatsapp-wrapper">
              {showWhatsAppTooltip && (
                <div className="whatsapp-tooltip">
                  <span className="whatsapp-tooltip-text">
                    {tooltipText || 'Chat with us on WhatsApp'}
                  </span>
                  <img
                    onClick={handleTooltipClose}
                    src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                    alt="close"
                    className="whatsapp-tooltip-close"
                  />
                </div>
              )}
              <div
                className={`${!showModal ? 'whatsApp' : ''} ${
                  showModal ? '' : showWhatsAppIcon ? 'showWhatsAppIcon' : ''
                }`}
                onClick={handleWhatsappWidget}
              >
                <div
                  className={`${!showModal ? 'whatsaAppIconContainer' : ''}`}
                />
                {true && !showModal && <span>Chat with us</span>}
              </div>
            </div>
          )}
        </div>
        <div>
          {isMobile() && showCallUsWidget && customerCareNumberFinal && (
            <div
              className={`${!showModal ? 'callUs' : ''} ${
                showModal ? '' : showCallUsIcon ? 'showCallUsIcon' : ''
              }`}
              onClick={() => {
                onCallUsIconClick();
                trackTemplateEvent('Cab_SEO_Call_Us_Icon_Clicked');
              }}
            >
              <div className={`${!showModal ? 'callUsIconContainer' : ''}`} />
              {true && !showModal && <span>Call us now</span>}
            </div>
          )}
        </div>
        {isMobile() && showTripAssistantButton ? fabInteraction() : <div></div>}
        {showCallusModalMweb && callUsForm()}
        {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
        !isMobile() ? (
          <div className="tripAssistant">
            {showTripAssistantTooltip && (
              <div className="tripassistant-tooltip">
                <span className="tripassistant-tooltip-text">
                  {tooltipText || 'Click to open Trip Assistant'}
                </span>
                <img
                  onClick={e => {
                    e.stopPropagation();
                    setShowTripAssistantTooltip(false);
                  }}
                  src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                  alt="close"
                  className="tripassistant-tooltip-close"
                />
              </div>
            )}
          </div>
        ) : (
          <div className="tripAssistant"></div>
        )}
        {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
        !isMobile() ? (
          <div className="tripAssistant2">
            <TripAssistant
              trackEvent={trackTemplateEvent}
              customerCareNumber={inboundCallNumberFinal}
              source={sourceCityName}
              destination={destinationCityName}
              autoOpenDelay={assistedFormOpenDelay}
              couponData={couponInfo}
              showTripAssistant={showTripAssistantButtonForDweb}
              showLeaveIntentForm={showLeaveIntentForm}
            />
          </div>
        ) : (
          <div className="tripAssistant2"></div>
        )}
        {showModal && isMobile() && showTripAssistantButton && (
          <AssistModal
            setShowModal={val => setShowModalWithDelay(val)}
            trackTemplateEvent={trackTemplateEvent}
            sourceCity={sourceCityName}
            destinationCity={destinationCityName}
            showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
            showCallUsForAssistedForm={showCallUsForAssistedForm}
            customerCareNumber={customerCareNumberFinal || ''}
            assistantWidgetText={assistantWidgetText}
            onCallUsIconClick={onCallUsIconClick}
            onWhatsAppIconClick={onWhatsAppIconClick}
            showInboundNumberOnAssistedForm={
              showInboundNumberOnAssistedForm || true
            }
            inboundCallNumber={inboundCallNumberFinal}
            inboundCallText={inboundCallText}
          />
        )}
        {showModal && isMobile() && showCallusModalMweb && (
          <CallUsModal
            setShowModal={val => setShowModalWithDelay(val)}
            trackTemplateEvent={trackTemplateEvent}
            showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
            showCallUsForAssistedForm={showCallUsForAssistedForm}
            customerCareNumber={customerCareNumberFinal}
            assistantWidgetText={assistantWidgetText}
            onCallUsIconClick={onCallUsIconClick}
            onWhatsAppIconClick={onWhatsAppIconClick}
            showModal={showModal}
          />
        )}
        <div className="cabSeoDtPage">
          <div className={`domChanger mobileShow makeSticky`}>
            <CabModifySearch
              isOverlayVisible={isOverlayVisible}
              overlayToggle={toggleOverlay}
              forwardDate={3}
              pickupTime={pickUpTime}
              defaultTripType={
                tripType === 'RT' ? OUTSTATION_ROUND_TRIP : travelFor
              }
              returnTime={dropTime}
              returnCloseFlagDefault={false}
              sourceCityCode={sourceCityCode}
              sourceCityName={sourceCityName}
              //   destinationCityCode={isPackage ? destinationCityCode : undefined}
              //   destinationCityName={isPackage ? destinationCityName : undefined}
              isMobileDevice={true}
              title={`${isPackage ? 'Multicity' : stateName} Cabs`}
            />
          </div>
        </div>
        <div className="multicityContainer">
          <Helmet>
            <title>{templateData.metaTitle}</title>
            <meta name="description" content={templateData.metaDescription} />
            <meta name="keywords" content={templateData.metaKeywords} />
            {templateData.ogTitle && (
              <meta property="og:title" content={templateData.ogTitle} />
            )}
            {templateData.ogDescription && (
              <meta
                property="og:description"
                content={templateData.ogDescription}
              />
            )}
            {templateData.twitterTitle && (
              <meta name="twitter:title" content={templateData.twitterTitle} />
            )}
            {templateData.twitterDescription && (
              <meta
                name="twitter:description"
                content={templateData.twitterDescription}
              />
            )}
            {templateData.ogImage && (
              <meta name="og:image" content={templateData.ogImage} />
            )}

            <link rel="canonical" href={templateData.sampleUrl} />
          </Helmet>
          {aggregateRating && (
            <ProductSchema
              data={aggregateRating}
              templateData={templateData}
              schemaMinFare={schemaMinFare}
              source={stateName}
            />
          )}
          {
            <div className="leftRightPaddingBreadCrumb">
              <BreadCrumb breadcrumb={templateData.breadcrumb} />
              {!(packages && packages.length > 0) &&
              showInboundCallNumberInDesktop ? (
                <InboundCallBox
                  inboundCallText={inboundCallText}
                  inboundCallNumber={inboundCallNumberFinal}
                />
              ) : (
                <div></div>
              )}
              <div className="">
                <PageHeader
                  title={templateData.h1Title}
                  extraInfo={templateData.metaDescription}
                  isMobileDevice={isMobileDevice}
                  url={templateData.sampleUrl}
                />
              </div>
            </div>
          }
          {templateData.viewLess && topRoutes?.cabTypes?.length > 0 ? (
            <div className="pageExtraInfo font15 appendTop5 leftRightPaddingBreadCrumb">
              <TruncateText
                whiteBackground={true}
                isHtml={true}
                viewLessHtml={templateData.viewLess}
                text={templateData.viewLess}
                isMobileDevice={isMobileDevice}
                textLength={0}
              />
            </div>
          ) : (
            <div></div>
          )}
          {
            <div className="makeFlex mcHeader leftRightPadding">
              {packages && packages.length > 0 && (
                <>
                  <h2 className="dhamSelectHeader dhamSelectHeader2 font20 appendTop10">
                    <span className="latoRegular blackText">
                      Explore Trip Prices for{' '}
                    </span>
                    <span
                      style={{ textDecoration: 'underline' }}
                      className="latoBold darkGreyText"
                    >
                      {`${stateName} Cab Packages`}
                    </span>
                  </h2>
                </>
              )}
              {packages && packages.length > 0 && (
                <div className="inboundCallBox">
                  {showInboundCallNumberInDesktop ? (
                    <InboundCallBox
                      inboundCallText={'Talk to agent (24x7)'}
                      inboundCallNumber={inboundCallNumberFinal}
                    />
                  ) : null}
                </div>
              )}
            </div>
          }
          {packages && packages.length > 0 && (
            <MultiCityPackages
              packages={packages}
              disableStopFilter={disableStopFilter}
              disableCabCardImage={disableCabCardImage}
              stopType={stopType}
              removeLeftRightPadding={false}
            />
          )}
          <>
            <br />
            <div className="leftRightPadding2">
              {topRoutes?.cabTypes?.length > 0 && (
                <TopCabsRoutes
                  h2={`Top Routes in ${stateName}`}
                  cityName={stateName}
                  routeType="In"
                  data={topRoutes}
                  enableAnchorTags={true}
                  reduceCssCalculations={false}
                />
              )}
            </div>
          </>
          <br />
          {cabRentalPrices && cabRentalPrices.length > 0 ? (
            <section className="visibilityAuto leftRightPadding">
              <h2>{`${stateName} Rental Cabs Prices`}</h2>
              <RentalCabPrice cabRentalPrices={cabRentalPrices} />
            </section>
          ) : null}
          <br />
          <br />
          <WhyChooseUs
            whyChooseUs={whyChooseUs}
            setShowModal={() => {
              trackTemplateEvent('Talk_to_an_expert_Click');
              setShowModalWithDelay(!showModal);
            }}
          />
          {routeImg && (
            <div className="whiteBackGroundColor">
              <img
                className="RouteImg makeFlex horizontalCenter lazyload"
                src={`${PUBLIC_URL}/static/public/${routeImg}`}
              />
            </div>
          )}
          {itineraryInfo && itineraryInfo.size > 0 ? (
            <MulticityRouteInfo itineraryInfo={itineraryInfo} />
          ) : null}
          {thingToKeepInMind && thingToKeepInMind.length > 0 ? (
            <ThingsToKeepInMind thingToKeepInMind={thingToKeepInMind} />
          ) : null}
          {dhamInfo && dhamInfo.length > 0 ? (
            <KnowMore
              dhamInfo={dhamInfo}
              trackTemplateEvent={trackTemplateEvent}
              packageName={stateName}
            />
          ) : null}
          {interlinks && interlinks.length > 0 ? (
            <div
              style={{ flexWrap: 'wrap' }}
              className={`cabsSeoWrap__Details makeFlex visibilityAuto leftRightPadding2 appendBottom10 appendTop20`}
            >
              {interlinks.map(({ title, links }) => {
                return (
                  <CompactList
                    titlePrefix={title}
                    titleSuffix={``}
                    list={links}
                    type={'bullets'}
                    className={'rightMargin'}
                  >
                    {(item: any, idx, style) => (
                      <li
                        key={`${item.text}_${idx}`}
                        className={`${
                          idx ? `paddingT10 paddingB10` : `paddingB10`
                        }`}
                      >
                        {item.url ? (
                          <a
                            className={`linkBoxFont `}
                            onClick={() => {
                              //TO DO: add omniture events from Dataloader
                            }}
                            href={item.url}
                          >
                            {item.text}
                          </a>
                        ) : (
                          <span>{item.text}</span>
                        )}
                      </li>
                    )}
                  </CompactList>
                );
              })}
            </div>
          ) : null}
          {templateData?.faqInfo?.faqs &&
          templateData.faqInfo.faqs.length > 0 ? (
            <section className="leftRightPadding mobileWhiteBackground paddingT5 paddingB5">
              <h2 className="knowMoreTitle font24 latoBold blackText appendBottom10 appendTop10">
                {templateData.faqInfo.faq_heading}
              </h2>
              <FaqSection
                data={templateData.faqInfo.faqs}
                trackTemplateEvent={trackTemplateEvent}
                pageUrl={setDeptAndReturnDateForMulticity(
                  templateData.faqInfo.page_url,
                  3,
                  3
                )}
              />
            </section>
          ) : null}
          <FooterSection template={templateData} />
        </div>
        {isOverlayVisible && (
          <div
            onClick={() => {
              toggleOverlay(false);
            }}
            className="searchWidgetModal mobileShow"
          ></div>
        )}
      </div>
    </AppContextProvider>
  );
};

MulticityPage.fetchData = async (_, match, urlObj) => {
  const {
    params: { multiCityId, stateId }
  } = match;
  let url;
  if (multiCityId) {
    url = `${DATA_LOADER_URL}/api/${
      multiCityId > 1 ? 'v2/' : ''
    }multiCityTemplateData/${multiCityId}?${urlObj.query}`;
  } else {
    if (stateId) {
      url = `${DATA_LOADER_URL}/api/stateTemplateData/${stateId}?${urlObj.query}&state=true`;
    }
  }
  let responseData;
  const response = await fetch(url);
  const textResponse = await response.text();
  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new DataLoaderError(
      `Unable to fetch city details of ${multiCityId}`,
      responseData.error
    );
  }

  return {
    ...responseData,
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey: stateId ? 'HTML_CSC_' + stateId : 'HTML_CMC_' + multiCityId
  };
};

export default MulticityPage;
